import { render, staticRenderFns } from "./SuperMenu.vue?vue&type=template&id=695ce44a"
import script from "./SuperMenu.vue?vue&type=script&lang=js"
export * from "./SuperMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports